export * from '@fhs/routing/src/routes/store-locator/_layout';
export { default } from '@fhs/routing/src/routes/store-locator/_layout';
